import _classCallCheck from "/zeit/45515ec9/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/zeit/45515ec9/node_modules/@babel/runtime/helpers/esm/createClass";
import { VALUE, IS_PROXY, TrackStateTree } from 'proxy-state-tree';
import { EventType } from './internalTypes';
export var Derived =
/*#__PURE__*/
function () {
  function Derived(cb) {
    _classCallCheck(this, Derived);

    this.cb = cb;
    this.isDirty = true;
    this.updateCount = 0;
    return this.evaluate.bind(this);
  }

  _createClass(Derived, [{
    key: "evaluate",
    value: function evaluate(eventHub, proxyStateTree, path) {
      var _this = this;

      if (!this.trackStateTree) {
        this.trackStateTree = proxyStateTree.getTrackStateTree();
        var pathAsArray = path.split('.');
        pathAsArray.pop();
        var parent = pathAsArray.reduce(function (curr, key) {
          return curr[key];
        }, this.trackStateTree.state);

        this.scope = function () {
          return _this.cb(parent, _this.trackStateTree.state);
        };

        proxyStateTree.onMutation(function (_, paths, flushId) {
          if (_this.isDirty) {
            return;
          }

          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = paths[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var _path = _step.value;

              if (_this.paths.has(_path)) {
                eventHub.emitAsync(EventType.DERIVED_DIRTY, {
                  path: _path,
                  flushId: flushId
                });
                _this.isDirty = true;
                return;
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        });
      }

      if (this.isDirty || this.value && this.value[IS_PROXY] && this.value[VALUE][proxyStateTree.PROXY] !== this.value) {
        this.value = this.trackStateTree.trackScope(this.scope);
        this.isDirty = false;
        this.paths = new Set(this.trackStateTree.pathDependencies);
        eventHub.emitAsync(EventType.DERIVED, {
          path: path,
          paths: Array.from(this.paths),
          updateCount: this.updateCount,
          value: this.value
        });
        this.updateCount++;
      } // Tracks the paths for the consumer of this derived value


      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.paths[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _path2 = _step2.value;
          var currentTree = proxyStateTree.currentTree;

          if (currentTree instanceof TrackStateTree) {
            currentTree.addTrackingPath(_path2);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return this.value;
    }
  }]);

  return Derived;
}();